<section>

  <div class="row mx-0">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <div class="p-2 d-flex justify-content-between align-items-center">
        <span class="fw-bold">{{ isFormView ? 'Registrar despiece' : 'Despiece' }} </span>
        <div class="d-flex gap-1">
          <app-custom-button [icon]="'pi pi-dollar'" [title]="'Distribuir Vr.Total'" [severity]="'primary'"
            [disabled]=" !breakdownsInlist || disableButtons"
            (onClick)="openDistributeTotalValueModal()"></app-custom-button>

          <app-custom-modal #distributeTotalValue [label]="'Seleccionar'" [header]="'Distribuir Valor Total'"
            [children]="componentDistributeTotalValue" [inputs$]="inputsForDistributeTotalValue$"
            [output$]="outputDistributeTotalValue$" [width]="'20vw'" [breakpoints]="breakpointsForDistributeTotalValue"
            hidden></app-custom-modal>

          <app-custom-button [icon]="'pi pi-percentage'" [title]="'Aplicar Descuento'" [severity]="'primary'"
            [disabled]="!breakdownsInlist || disableButtons" (onClick)="openApplyDiscountModal()"></app-custom-button>
          <app-custom-modal #applyDiscount [label]="'Seleccionar'" [header]="'Aplicar Descuento'"
            [children]="componentApplyDiscount" [inputs$]="inputsForApplyDiscount$" [output$]="outputApplyDiscount$"
            [width]="'30vw'" [breakpoints]="breakpointsForDiscount" hidden></app-custom-modal>

          <app-custom-button [title]="'Nuevo Despiece'" [label]="'Nuevo Despiece'" [severity]="'success'"
            [width]="'7.5rem'" (onClick)="openArticleSelectionModal()" [disabled]="disableButtons"></app-custom-button>
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Equipos'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        </div>
      </div>
    </div>
  </div>
  <div class="row mx-0" [hidden]="!isFormView">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-register-breakdown [quotationSolution]="quotationSolution" [breakdown]="breakdownContract"
        [priceListId]="priceListId" [rateDiscountMax]="userAuthenticated.rateDiscountMax"
        [typeQuotation]="quotationTypeId" (isFormView)="getFormView($event)"
        (updateListDetail)="updateSolution()"></app-register-breakdown>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-custom-table [headers]="breakdownHeader" [data]="breakdownData" [actions]="tableActionsBreakdown"
      [showCheckbox]="!disableButtons" [checkBoxAction]="checkboxActions"
      [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getAllBreakdownsByQuotationSolution()"
      (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
    </app-custom-table>
  </div>
</section>